import * as React from 'react'
import * as UniversalRouter from 'universal-router'
import { PreferencesConnected } from './component'
import * as Constants from './constants'

export const routes = [
  {
    action: (context: UniversalRouter.ActionContext) => <PreferencesConnected />,
    path: `${Constants.URL_HOME}/:community_identifier`,
  },
]
